import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'audioChannelConfig';

export class ChannelConfig extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
